//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gsap } from "gsap"
import Theme from '@/listing-app/mixins/Theme'
import Promo from "@/listing-app/components/detail/Promo.vue"
export default {
	name: "Footer",
	mixins: [Theme],
	props: [
		"availability",
		"priceMask",
		"price",
		"promotion",
		"bdrm",
		"upgrade",
		"term",
		"legacy",
		"salesplan"
	],
	components: {
		appPromo: Promo
	},
  data() {
    return {
      scrollerVisible: true,
      cost: {
        standard: undefined,
        adjusted: undefined
      }
    }
  },
  computed: {
    applyURL() {
			if (this.legacy) {
				return url = document.querySelector("#legacyApplyEndpointURL").value
			}

      let input = document.querySelector("#applyEndpointURL")
      let url = input.getAttribute("value")

      if (url && input.getAttribute("data-append")?.toLowerCase() == "true") {
        url = `${url}&Term=${this.term}&Salesplan=${this.salesplan}`
      }

      return url
    },
    apply() {
      let text
      switch (this.availability.AvStatus[0]) {
        case "waitlist":
          text = "Apply for waitlist"
          break
        default:
          text = "Apply"
          break
      }
      return text
    }
  },
  methods: {
    tween() {
			let price = {...this.price}
			let time = {}

			time.standard = (Math.abs(this.cost.standard - price.standard)*3)/1000
			time.adjusted = (Math.abs(this.cost.adjusted - price.adjusted)*3)/1000

			time.standard = time.standard > .75 ? .75 : time.standard < .25 ? .25 : time.standard
			time.adjusted = time.adjusted > .75 ? .75 : time.adjusted < .25 ? .25 : time.adjusted

			gsap.to(this.cost, { standard: price.standard, duration: time.standard })
			if (price.adjusted && this.cost.adjusted !== 0) {
				gsap.to(this.cost, { adjusted: price.adjusted, duration: time.adjusted })
			}
			else if (this.cost.adjusted === 0) {
				this.cost.adjusted = price.adjusted
			}
			else {
				this.cost.adjusted = 0
			}
    },
    set_scroller_visibility() {
      if (window.pageYOffset > 10) {
        this.scrollerVisible = false
      } else {
        this.scrollerVisible = true
      }
    },
    set_body_padding(e, remove = false) {
      let padding = this.$el.offsetHeight
      if (!remove) {
        document.body.style.paddingBottom = `${padding}px`
      }
      else {
        document.body.style.paddingBottom = ''
      }
    }
  },
  filters: {
    currency(val) {
      return "$" + parseInt(val).toLocaleString()
    }
  },
  updated() {
    this.$emit("updated", this.$el.offsetHeight)
	},
	watch: {
		price() {
			this.tween()
		}
	},
  created() {
    this.tween()
  },
  mounted() {
    this.$emit("updated", this.$el.offsetHeight)
    this.set_scroller_visibility()
    this.set_body_padding(null)
    window.addEventListener("scroll", this.set_scroller_visibility)
    window.addEventListener("resize", this.set_body_padding)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.set_scroller_visibility)
    window.removeEventListener("resize", this.set_body_padding)
    this.set_body_padding(null, true)
  }
}
